export const actionConst = {
    OPEN_WARRANTY_MODAL: 'OPEN_WARRANTY_MODAL',
    CLOSE_WARRANTY_MODAL: 'CLOSE_WARRANTY_MODAL',
    OPEN_WARRANTY_INFO_MODAL: 'OPEN_WARRANTY_INFO_MODAL',
    CLOSE_WARRANTY_INFO_MODAL: 'CLOSE_WARRANTY_INFO_MODAL',
    SHOW_WARRANTY_STATE_OK: 'SHOW_WARRANTY_STATE_OK',
    HIDE_WARRANTY_STATE_OK: 'HIDE_WARRANTY_STATE_OK',
    FETCH_FILETYPES_REF: 'FETCH_FILETYPES_REF',
    POST_WARRANTY_INFO_OK: 'POST_WARRANTY_INFO_OK'
};
